import { defineMessage } from '../../services/localization';

export const messages = {
    downloadButton: defineMessage('download_codes_txt_file'),
    checkboxText: defineMessage('yes_i_have_saved_the_backup_codes'),
    doneButton: defineMessage('done'),
    fileName: defineMessage('backupcodes'),
    copyButton: defineMessage('copy'),
    copiedToast: defineMessage('copied_to_clipboard'),
};
